export default {
  background: '#65554D',
};
